<template>
  <div class="MainStepsForm">
    <div v-show="tabIdx == 'tab1'" class="container">
      <a-alert
        message="中国知链为你自行上传的作品进行版权存证，不对您上传内容的真实性进行验证"
        type="warning"
        show-icon
      />

      <steps :stepIdx="4"></steps>

      <div class="commonWhiteBg">
        <div class="ant-popover-arrow"></div>
        <div class="commonTitle">版权取证</div>
        <div class="formWrap">
          <el-form ref="form" :model="form" :rules="rules" label-width="150px">
            <el-form-item label="选择存证文件" prop="evidenceFileIdx">
              <el-select
                v-model="form.evidenceFileIdx"
                multiple
                clearable
                placeholder="请选择已存证名称"
                @change="chooseFile"
              >
                <el-option
                  v-for="(item, index) in fileList"
                  :key="index"
                  :label="item.sourceName"
                  :value="index"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设定取证名称" prop="subject">
              <el-input v-model="form.subject"></el-input>
            </el-form-item>
            <el-form-item
              label="上传取证文件"
              class="uploadWraper"
              ref="uploader"
              prop="files"
            >
              <el-upload
                class="commonUpload"
                drag
                :action="uploadUrl"
                :headers="uploadHeaders"
                :on-success="uploadSuccess"
                :on-remove="removeFile"
                 :before-upload="uploadBefore"
                multiple
              >
                <div class="commonUploadInner">
                  <i class="iconfont iconUpload">&#xe647;</i>
                  <div class="el-upload__text">
                    <div>将文件拖到此处，或<em>点击上传</em></div>
                    <div>支持扩展名：.rar .zip .doc .docx .pdf .jpg...</div>
                  </div>
                </div>
              </el-upload>
              <a-alert class="tips" type="warning">
                <div slot="message">温馨提示：</div>
                <div slot="description">
                  1、同一批的存证文件归属于同一标签，不支持重置；<br />
                  2、支持文件批量上传，一次不能超过10个文件；<br />
                  3、文件永久保全。<br />
                  4、超过100M的文件，存证收费将会相应增加。
                </div>
              </a-alert>
            </el-form-item>
            <el-form-item label="取证相关描述" prop="description">
              <el-input
                v-model="form.description"
                :rows="3"
                placeholder="请输入您对取证内容的详细描述"
                type="textarea"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="支付方式"
              prop="paymode"
              class="choosePayStyle"
            >
              <el-radio-group v-model="form.paymode">
                <el-radio :label="1">
                  <span class="onlyText"
                    >中国知链会员权益支付（当前存证次数可用{{
                      vipInfo ? vipInfo.obtainCount : 0
                    }}次）</span
                  >
                </el-radio>
                <el-radio :label="2">
                  <i class="iconfont aliPayColor"> &#xe634; </i>
                  <span>支付宝支付</span></el-radio
                >
                <el-radio :label="3">
                  <i class="iconfont weChatColor"> &#xe633; </i>
                  <span>微信支付</span></el-radio
                >
              </el-radio-group>
              <router-link class="buyVip" :to="{ path: '/Vip' }"
                >购买会员</router-link
              >
            </el-form-item>
            <el-form-item label="支付金额" v-if="form.paymode != 1">
              <div>
                <em class="bigPrice"> {{ form.orderAmount }} </em> 元
              </div>
            </el-form-item>
            <el-form-item class="submitRow">
              <el-button type="primary" @click="onSubmit">提交存证</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
    <result-view v-if="tabIdx == 'tab2'" v-bind="form" @set-tab-idx="setTabIdx">
    </result-view>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Steps from "../../components/Steps";
import resultView from "./components/resultView";
import {
  queryExistOrderItems,
  queryPaymentOrderByOutBizNp,
} from "@/api/EvidenceService";
import { mixinsScrollErrorPosition } from "../../../../mixins";
export default {
  name: "ObtainEvidenceInputForm",
  mixins: [mixinsScrollErrorPosition],
  components: { Steps, resultView },
  data() {
    return {
      tabIdx: "tab1",
      fileList: [],
      form: {
        files: [], // 文件列表
        subject: "", // 名称
        evidenceFileIdx: [], // 存证文件
        evidenceFile: [],
        description: "",
        paymode: 3,
        orderAmount: 0,
      },
      rules: {
        subject: [
          { required: true, message: "请输入取证名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        files: [
          { required: true, message: "请上传取证文件", trigger: "change" },
        ],
      },
      uploadUrl: `${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/`,
      uploadHeaders: {
        Authorization: this.$store.getters.token,
        "Product-Mode": "READ",
        "Terminal-Code": "IPCHAIN2" + this.$store.getters.terminalCode,
        "Terminal-Type": "WEB",
        "Merchant-Id": "2",
      },
    };
  },
  mounted() {
    this.init();
  },
  computed: {
    ...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo"]),
  },
  methods: {
    init() {
      queryExistOrderItems().then(({ data }) => {
        this.fileList = data;
      });
    },
    chooseFile() {
      let files = [];
      for (let i = 0; i < this.form.evidenceFileIdx.length; i++) {
        const element = this.form.evidenceFileIdx[i];
        files.push(this.fileList[element]);
      }
      this.form.evidenceFile = files;
      this.calAmount();
    },
    async onSubmit() {
      console.log("onSubmit..");
      try {
        const formBaseResult = await this.$refs["form"].validate();
          if(this.form.files.length>10){
           this.$message.error("不能超过10个文件")
          return
        }
      } catch (error) {
        // 有错误,定位到错误
        // eslint-disable-next-line
        console.error(error);
        this.mixinsScrollView();
        return;
      }
      this.setTabIdx("tab2");
    },
    setTabIdx(tabIdx) {
      this.tabIdx = tabIdx;
    },
    calAmount() {
      let amount = 0;
      let obtainConfig = this.evidencePaymentPrice.obtain;
      for (let i = 0; i < this.form.files.length; i++) {
        const file = this.form.files[i];
        //
        amount +=
          obtainConfig.basePrice * 1 +
          Math.ceil((file.used * 1) / (1024 * 1024)) *
            obtainConfig.sizePrice *
            1;
      }

      for (let i = 0; i < this.form.evidenceFile.length; i++) {
        const file = this.form.evidenceFile[i];
        //
        amount +=
          obtainConfig.basePrice * 1 +
          Math.ceil((file.used * 1) / (1024 * 1024)) *
            obtainConfig.sizePrice *
            1;
      }

      this.form.orderAmount = amount.toFixed(2);
    },
      uploadBefore(file) {
        const NoPassFileTypes=['.exe','.dmg','.js','.html','.json','.xml','.dtd','.jsp','.php','.asp','.aspx']
        const fileName=file.name
       const fileEnd=fileName.substring(fileName.indexOf("."))
				const isFileTypePass = !NoPassFileTypes.includes(fileEnd)
				const isLt100M = file.size / 1024 / 1024 < 100;

				if (!isFileTypePass) {
					this.$message.error('上传文件格式不能为'+fileEnd);
				}
				if (!isLt100M) {
					this.$message.error('上传文件大小不能超过 100MB!');
				}
				return isFileTypePass&&isLt100M;
			},
    uploadSuccess(response, file, fileList) {
      console.log(arguments);
      this.$refs.uploader.clearValidate();
      this.form.files.push(response);
      this.calAmount();
    },
    removeFile(file, fileList) {
      let that = this;
      let response = file.response;
      if (response) {
        let index = that.form.files.findIndex((t) => {
          return t.sourceCode == response.sourceCode;
        });
        if (index > -1) {
          that.form.files.splice(index, 1);
        }
      }
      console.log(file, fileList);
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../../assets/css/inputForm.scss";
.commonWhiteBg {
  /deep/ .ant-popover-arrow {
    left: 85%;
  }
}
</style>
